export default "__VITE_ASSET__4d5f01d7__"